import type { MatchPlan } from './match-plan.type.ts';

// NB: backend class that models this is the ruby Jsonb::GenericTextStore
export interface MatchPlanExtension extends MatchPlan {}
export class MatchPlanExtension {}

const Registration = {
  kind: 'object',
  name: 'match-plan',
  features: MatchPlanExtension,
};
export default Registration;
